import React from 'react'
import PropTypes from 'prop-types'
import { User, Lock, Info } from 'lucide-react'
import './ProfileTabs.css'

/**
 * Profile Tabs Component
 *
 * Tab navigation for profile sections.
 *
 * @param {Object} props - Component props
 * @param {string} props.activeTab - Currently active tab ID
 * @param {Function} props.onTabChange - Tab change handler
 */
const ProfileTabs = ({ activeTab, onTabChange }) => {
	const tabs = [
		{
			id: 'info',
			label: 'Personal Information',
			icon: User,
		},
		{
			id: 'security',
			label: 'Security',
			icon: Lock,
		},
		{
			id: 'account',
			label: 'Account',
			icon: Info,
		},
	]

	return (
		<div className="profile-tabs">
			<div className="profile-tabs__list" role="tablist">
				{tabs.map((tab) => {
					const Icon = tab.icon
					const isActive = activeTab === tab.id

					return (
						<button
							key={tab.id}
							type="button"
							role="tab"
							aria-selected={isActive}
							aria-controls={`panel-${tab.id}`}
							className={`profile-tabs__tab ${isActive ? 'profile-tabs__tab--active' : ''}`}
							onClick={() => onTabChange(tab.id)}
						>
							<Icon size={18} className="profile-tabs__tab-icon" />
							<span className="profile-tabs__tab-label">{tab.label}</span>
						</button>
					)
				})}
			</div>
		</div>
	)
}

ProfileTabs.propTypes = {
	activeTab: PropTypes.oneOf(['info', 'security', 'account']).isRequired,
	onTabChange: PropTypes.func.isRequired,
}

export default ProfileTabs
